import { Helmet } from "react-helmet-async";

const SITE_URL = "https://donnees-et-droit.fr";

/**
 * Per-route SEO metadata: canonical, title, description, OG/Twitter overrides
 * and optional robots directives.
 */
export function SEO({
    path = "/",
    title,
    description,
    ogTitle,
    ogDescription,
    robots = "index, follow, max-image-preview:large",
}) {
    const canonical = `${SITE_URL}${path}`;
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="robots" content={robots} />
            <link rel="canonical" href={canonical} />
            <meta property="og:url" content={canonical} />
            <meta property="og:title" content={ogTitle || title} />
            <meta
                property="og:description"
                content={ogDescription || description}
            />
            <meta name="twitter:title" content={ogTitle || title} />
            <meta
                name="twitter:description"
                content={ogDescription || description}
            />
        </Helmet>
    );
}
